import { useCompany } from "@admin/hooks/useCompany";

import { AcceptedProductsTable } from "./AcceptedProductsTable";
import { PicklesTable } from "./PicklesTable";
import { ProcessedProductsTable } from "./ProcessedProductsTable";
import { SuppliersTable } from "./SuppliersTable";

interface MyListsProps {
  selectedLocationId?: string;
}

export function MyLists({ selectedLocationId }: MyListsProps) {
  const { company } = useCompany();
  return (
    <div className="flex flex-col gap-5">
      <SuppliersTable companyId={company?.companyId} />
      <div className="grid grid-cols-2 gap-7.5">
        <div className="col-span-1">
          <AcceptedProductsTable
            companyId={company?.companyId}
            selectedLocationId={selectedLocationId}
          />
        </div>
        <div className="col-span-1">
          <ProcessedProductsTable
            companyId={company?.companyId}
            selectedLocationId={selectedLocationId}
          />
        </div>
        <div className="col-span-1  ">
          <PicklesTable
            companyId={company?.companyId}
            selectedLocationId={selectedLocationId}
          />
        </div>
      </div>
    </div>
  );
}
